/* eslint no-useless-escape: 0 */
import { Address, Phone, Civility } from 'types';

const MAX_ADDRESS_LINE_LENGTH = 64;

export const createAddressObject = (
  address: string,
  zipCode: string,
  city: string,
  country: string,
  geoLoc: { latitude: number; longitude: number },
  type?: 'DEFAULT' | 'FACT',
  name?: string,
): Address => {
  const [addressLine1, addressLine2, addressLine3, addressLine4] =
    address.match(new RegExp(`[\\s\\S]{1,${MAX_ADDRESS_LINE_LENGTH}}`, 'g')) || [];
  return {
    addressLine1,
    addressLine2,
    addressLine3,
    addressLine4,
    zipCode,
    city,
    country,
    geoLoc,
    type: type || 'DEFAULT',
    name,
  };
};

export const createPhoneObject = (number: string, type: 'SELLER', validationDate: string): Phone => ({
  number,
  type,
  validationDate,
});

export const createCivilityObject = (civility?: string): Civility | undefined => {
  switch (civility) {
    case 'M.':
      return { id: 1, abbr: 'M.', code: 'M', label: 'Monsieur' };
    case 'Mme':
      return { id: 2, abbr: 'Mme', code: 'MME', label: 'Madame' };
    case 'Mlle.':
      return { id: 2, abbr: 'Mlle.', code: 'MLLE', label: 'Mademoiselle' };
    default:
      return undefined;
  }
};

export const shouldValidatePhone = (phone: string, defaultPhone: Phone | undefined): boolean => {
  if (!defaultPhone || phone !== defaultPhone.number || !defaultPhone.validationDate) {
    return true;
  }

  const now = new Date();
  const validationDate = new Date(defaultPhone.validationDate);
  return validationDate.getTime() < now.getTime() - 1000 * 3600 * 24 * 30;
};

// don't sent '' to classified management because it doesn't allow it
export const undefinedIfEmpty = (val?: string): string | undefined => (val && val.trim().length > 0 ? val : undefined);
